import React from "react";
import { Instagram, Linkedin } from "lucide-react";

const socials = [
  {
    id: "instagram",
    href: "https://www.instagram.com/gifting.concierge",
    label: "Gifting Concierge on Instagram",
    Icon: Instagram,
  },
  {
    id: "linkedin",
    href: "https://www.linkedin.com/company/gifting-concierge/",
    label: "Gifting Concierge on LinkedIn",
    Icon: Linkedin,
  },
];

function FooterBrand() {
  return (
    <div className="flex items-center gap-3">
      <img
        src="/logo.png"
        alt="Gifting Concierge"
        className="h-10 w-10 object-contain bg-[#FDFBF7] rounded-full p-1"
      />
      <div>
        <p className="font-serif-display text-lg text-[#FDFBF7] leading-none">
          Gifting Concierge
        </p>
        <p className="overline text-[10px] text-[#D19C72] mt-1">
          Wrapped with Love
        </p>
      </div>
    </div>
  );
}

function FooterSocials() {
  return (
    <div className="flex items-center gap-4">
      {socials.map(({ id, href, label, Icon }) => (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`footer-${id}`}
          aria-label={label}
          className="w-9 h-9 rounded-full border border-[#FDFBF7]/25 text-[#FDFBF7]/80 hover:text-[#2A1D15] hover:bg-[#D19C72] hover:border-[#D19C72] flex items-center justify-center transition-colors duration-300"
        >
          <Icon className="w-[18px] h-[18px]" strokeWidth={1.6} />
        </a>
      ))}
    </div>
  );
}

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2A1D15] text-[#FDFBF7]/70 border-t border-[#FDFBF7]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <FooterBrand />
        <FooterSocials />
        <p className="text-xs font-light tracking-wide">
          © {new Date().getFullYear()} Gifting Concierge. All gifts crafted with care.
        </p>
      </div>
    </footer>
  );
}
